export default {
  padding: {
    top: '2.5rem',
    right: '1.875rem',
    bottom: '1.875rem',
    left: '1.875rem',
    mobile: {
      top: '2.5rem',
      right: '1.25rem',
      bottom: '1.25rem',
      left: '1.25rem',
    },
  },
  maxWidth: '36.5625rem', // 633px
  narrow: {
    maxWidth: '26.25rem',
  },
  overlay: {
    padding: {
      top: '0.9375rem',
      right: '0.9375rem',
      bottom: '0.9375rem',
      left: '0.9375rem',
    },
  },
  closeButton: {
    padding: {
      top: '.75rem',
      right: '.75rem',
      bottom: '.75rem',
      left: '.75rem',
    },
    mobile: {
      top: '1.25rem',
      right: '1.25rem',
    },
    top: '0.625rem',
    right: '0.625rem',
    width: '.75rem',
    label: {
      padding: {
        right: '0',
      },
    },
  },
  body: {
    margin: {
      bottom: '2.875rem',
    },
    padding: {
      x: '1.875rem',
      y: '0',
    },
  },
};
